import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"150px"} }



export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    title: {},
    text: {},
    loading: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "d-flex justify-center py-4 align-center",
    "max-width": "400",
    "prepend-icon": "mdi-help",
    text: _ctx.text,
    title: _ctx.title
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        text: "确认",
        color: "primary",
        loading: _ctx.loading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('confirm')))
      }, null, 8, ["loading"]),
      _createVNode(_component_v_btn, {
        text: "取消",
        color: "error",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('cancel')))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["text", "title"]))
}
}

})